import '@missions/ui/styles.css';

/** Unknown host / slug: neutral page (no tenant branding is known). Rendered without providers. */
export function WorkspaceNotFound() {
  return (
    <main className="ws-404">
      <img src="/brand/missions-logo.png" alt="Missions" height={28} />
      <h1>Workspace not found</h1>
      <p>
        There’s no workspace at <b>{window.location.host}</b>
        {window.location.pathname.length > 1 ? <b>{window.location.pathname.split('/').slice(0, 2).join('/')}</b> : null}. Check the link you were given, or ask your
        workspace admin for the right address.
      </p>
      <a className="ui-btn primary" href="https://devninjaweb.com" rel="noopener">
        Learn about Missions
      </a>
    </main>
  );
}
